import { el } from "@dhx/ts-common/dom";
import { defaultFontSizeByBlock } from "../constants";
import { Block } from "../models/Block";
import { TextNode } from "../models/TextNode";
import { IStyle, Modifier } from "../types";

export function calcTextNodeStyle(modifiers: IStyle) {
	const style: any = {};
	for (const key in modifiers) {
		if (!modifiers[key]) {
			continue;
		}
		switch (key) {
			case Modifier.bold:
				style["font-weight"] = "bold";
				break;
			case Modifier.italic:
				style["font-style"] = "italic";
				break;
			case Modifier.underline:
				if (style["text-decoration"]) {
					style["text-decoration"] += " underline";
				} else {
					style["text-decoration"] = "underline";
				}
				break;
			case Modifier.strike:
				if (style["text-decoration"]) {
					style["text-decoration"] += " line-through";
				} else {
					style["text-decoration"] = "line-through";
				}
				break;
			case Modifier.color:
				style.color = modifiers[key];
				break;
			case Modifier.background:
				style.background = modifiers[key];
				break;
			case Modifier.fontFamily:
				style["font-family"] = modifiers[key];
				break;
			case Modifier.fontSize:
				style["font-size"] = modifiers[key];
				break;
		}
	}
	return style;
}

export function calcBlockStyle(modifiers: IStyle) {
	const style: any = {};
	for (const key in modifiers) {
		if (!modifiers[key]) {
			continue;
		}
		switch (key) {
			case Modifier.align:
				style["text-align"] = modifiers[key];
		}
	}
	return style;
}

export function blockStyleToTag(style: IStyle) {
	if (style[Modifier.style]) {
		return style[Modifier.style];
	}
	return "p";
}

export function blockquoteWrapper(style: IStyle, blockIndex: number) {
	if (style[Modifier.blockquote]) {
		return (...args) =>
			el(
				"blockquote",
				{
					dhx_offset: blockIndex,
				},
				[el(...args)]
			);
	}
	return (...args) => el(...args);
}

export function getComputedNodeStyle(textNode: TextNode, block: Block, defaultModifiers) {
	const computed = {};

	for (const key in textNode.style) {
		computed[key] = textNode.style[key];
	}

	if (!computed[Modifier.fontSize]) {
		if (block.style[Modifier.style] && block.style[Modifier.style] !== "p") {
			computed[Modifier.fontSize] = defaultFontSizeByBlock[block.style[Modifier.style]];
		} else {
			computed[Modifier.fontSize] = defaultModifiers[Modifier.fontSize];
		}
	}

	if (!computed[Modifier.fontFamily]) {
		computed[Modifier.fontFamily] = defaultModifiers[Modifier.fontFamily];
	}

	return computed;
}

export function getComputedBlockStyle(block: Block, defaultModifiers) {
	const computed = {};

	for (const key in block.style) {
		computed[key] = block.style[key];
	}

	if (!computed[Modifier.style]) {
		computed[Modifier.style] = defaultModifiers[Modifier.style];
	}
	if (!computed[Modifier.align]) {
		computed[Modifier.align] = defaultModifiers[Modifier.align];
	}
	if (!computed[Modifier.blockquote]) {
		computed[Modifier.blockquote] = defaultModifiers[Modifier.blockquote];
	}

	return computed;
}

export function isEmptyBlockStyle(style: IStyle) {
	return !style[Modifier.blockquote] && !style[Modifier.align];
}
